exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-outline-secondary[data-v-4b1c4009] {\n    border-color: rgb(140, 140, 140);\n    border-left: none;\n}\n.input-with-addon[data-v-4b1c4009] {\n    border-right: none;\n}\n.address-add-btn[data-v-4b1c4009] {\n    color: black;\n}\n", ""]);

// exports
